import React, { useState } from "react";

const ExpandableContent = ({ content, heading }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleContent = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header} onClick={toggleContent}>
        <span style={styles.title}>{heading}</span>
        <span style={styles.arrow}>
          {isOpen ? "⬆" : "⬇"} {/* Up or Down arrow based on state */}
        </span>
      </div>
      {isOpen && <div style={styles.content}>{content}</div>}
    </div>
  );
};

const styles = {
  container: {
    border: "1px solid #ddd",
    borderRadius: "8px",
    overflow: "hidden",
    width: "75%",
    margin: "20px auto",
    fontFamily: "Arial, sans-serif",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    backgroundColor: "#f5f5f5",
    cursor: "pointer",
    fontWeight: "bold",
  },
  title: {
    fontSize: "16px",
  },
  arrow: {
    fontSize: "18px",
  },
  content: {
    padding: "15px 20px",
    backgroundColor: "#ffffff",
    fontSize: "14px",
    color: "#333",
  },
};

export default ExpandableContent;
